// removed by extract-text-webpack-plugin
module.exports = {"container":"_1CSuygNql-t5Y7cFEI-hem","buttons":"u3BTG8z9kZWcToBB5lF4B","notification":"E5PGTwjc5j1S8SJSUdU6U","fieldsAssigned":"pWC964B7y-o9oHfCkIVMH"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/PrepareTemplate/styles.css
// module id = 3123
// module chunks = 0